import Loess from 'loess'
export default  {
    methods: {
         smoothLineLoess(x,y,grid,options){
             let model = new Loess(
                 {
                     x: x,
                     y: y
                 }, options)
             let data = model.grid([grid])
             let fitted = model.predict(data)
             return {
                 data:data,
                 fitted:fitted
             }
        }
    }
};